interface ITagDotIcon {
  color?: string;
}

export const TagDotIcon = (props: ITagDotIcon) => {
  const { color = '#1FC16B' } = props;

  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.83203 6C3.83203 4.34315 5.17518 3 6.83203 3C8.48889 3 9.83203 4.34315 9.83203 6C9.83203 7.65685 8.48889 9 6.83203 9C5.17518 9 3.83203 7.65685 3.83203 6Z"
        fill={color}
      />
    </svg>
  );
};
